import { PageData } from 'analytics';
import { useEffect } from 'react';
import analytics from './analytics';

export const useTrack = (eventName: string, payload?: Record<string, any>) => {
  return useEffect(
    () => {
      analytics()?.track(eventName, payload);
    },
    [],
  );
};

export const usePage = (pageData?: PageData) => {
  return useEffect(
    () => {
      analytics()?.page(pageData);
    },
    [],
  );
};
